import { RequestCreationSuccess } from '@features/cx/shared/components/RequestCreationSuccess';
import { useLocation, useNavigate } from 'react-router-dom';

function PaymentReceiptSuccessPage() {
  const navigate = useNavigate();
  const { formData, ...apiResponse } = useLocation().state || {};
  console.log('debug payment success form', formData)
  console.log('debug payment success response', apiResponse)

  // Extract firstName and lastName from formData
  const firstName = formData?.firstName || formData?.customerInfo?.firstName || apiResponse?.result?.consumer?.consumerName;
  const lastName = formData?.lastName || formData?.customerInfo?.lastName || '';
  const consumerNo = formData?.consumerNo || formData?.customerInfo?.consumerNo || apiResponse?.result?.consumer?.consumerNo;
  
  // You can also get the full customer info object
  const customerInfo = formData?.customerInfo || {
    firstName: formData?.firstName,
    lastName: formData?.lastName,
    email: formData?.email,
    contactNumber: formData?.contactNumber,
    consumerNo: formData?.accountNumber,
  };

  
  const requestData = {
    ...apiResponse,
    formData: {
      ...formData,
      // Ensure customer data is available at the top level
      firstName,
      lastName,
      consumerNo,
      customerInfo
    }
  };
  console.log('Payment Receipt Data:', requestData);

  if (!requestData) {
    return (
      <div className="max-w-4xl mx-auto p-6 text-center">
        <h2 className="text-xl font-semibold text-gray-700 mb-4">No Payment Data Found</h2>
        <p className="text-gray-500 mb-6">Unable to display payment receipt. Please try again.</p>
        <button 
          onClick={() => navigate('/cx/payments')}
          className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Return to Payments
        </button>
      </div>
    );
  }

  return (
    <div>
      {/* Optional: Display customer name in the header */}
      <div className="mb-4 p-4 bg-gray-50 rounded-lg">
        <h2 className="text-lg font-semibold text-gray-800">
          Payment Receipt for {firstName} {lastName}
        </h2>
        <p className="text-sm text-gray-600">Account: {consumerNo}</p>
      </div>
      
      <RequestCreationSuccess 
        requestData={requestData}
        requestType="payment"
        onReturnToDashboard={() => navigate('/cx/dashboard')}
        onAddNewRequest={() => navigate('/cx/payments/create')}
      />
    </div>
  );
}

export default PaymentReceiptSuccessPage;